"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SquareView_1 = require("./SquareView");
var types_1 = require("chess-fen/types");
exports.PromotionView = function (_a) {
    var Coordinate = _a.Coordinate, Piece = _a.Piece, onPromotion = _a.onPromotion, onClose = _a.onClose, _b = _a.style, style = _b === void 0 ? {} : _b, props = __rest(_a, ["Coordinate", "Piece", "onPromotion", "onClose", "style"]);
    var board = props.board;
    var PromotionPiece = function (_a) {
        var piece = _a.piece;
        return (react_1.default.createElement("div", { className: "chess-board-promotion--piece", onClick: function () { return onPromotion(board.toMove + " " + piece); } }, board.pieceTheme[board.toMove + " " + piece](props)));
    };
    return (react_1.default.createElement(SquareView_1.SquareView, __assign({}, props),
        react_1.default.createElement("div", { style: __assign({ transform: (((!board.rotated && board.toMove === "black") || (board.rotated && board.toMove === "white"))
                    ? "translate(0, calc(-75% - 15px))" : "none") }, style), className: "chess-board-promotion" },
            react_1.default.createElement(PromotionPiece, { piece: types_1.Piece.Queen }),
            react_1.default.createElement(PromotionPiece, { piece: types_1.Piece.Rook }),
            react_1.default.createElement(PromotionPiece, { piece: types_1.Piece.Bishop }),
            react_1.default.createElement(PromotionPiece, { piece: types_1.Piece.Knight }),
            react_1.default.createElement("div", { className: "chess-board-promotion--close", onClick: onClose }, "close"))));
};
exports.default = exports.PromotionView;
